import { SerializableObject } from '../../core';

import { NotificationActionType } from '../other/notification-action-type.enum';

export class NotificationAction extends SerializableObject {
  public text: string;
  public type: NotificationActionType;
  public url: string;
}
